// Export factory functions and methods

export { equals } from "./equals.js";
export { from } from "./from.js";
export { fromHex } from "./fromHex.js";
// Export type definitions
export type {
	StorageValueLike,
	StorageValueType,
} from "./StorageValueType.js";
export { SIZE } from "./StorageValueType.js";
export { toHex } from "./toHex.js";
export { toUint256 } from "./toUint256.js";
